import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

function ChannelMessageViewer({ darkMode }) {
  const [searchParams] = useSearchParams();
  const channel = searchParams.get('channel') || 'LongFast';
  const [messages, setMessages] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [fromFilter, setFromFilter] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [nodes, setNodes] = useState([]);

  const fetchNodes = async () => {
    try {
      const res = await fetch('/api/mqtt/nodeinfo/list');
      const data = await res.json();
      setNodes(data);
    } catch (err) {
      console.error('Error loading nodes', err);
    }
  };

  const fetchMessages = async () => {
    try {
      const query = new URLSearchParams();
      if (channel) query.set('value', channel);
      if (fromFilter) query.set('from', fromFilter);
      if (startDate) query.set('timestampStart', new Date(startDate).toISOString());
      if (endDate) query.set('timestampEnd', new Date(endDate).toISOString());

      const res = await fetch(`/api/mqtt/text/tag?${query.toString()}`);
      const data = await res.json();
      setMessages(data);
      setFiltered(data);
    } catch (err) {
      console.error('Error loading messages', err);
    }
  };

  useEffect(() => {
    fetchNodes();
    fetchMessages();
    const interval = setInterval(() => {
      fetchNodes();
      fetchMessages();
    }, 30000);
    return () => clearInterval(interval);
  }, [channel, fromFilter, startDate, endDate]);

  const getNodeName = (fromId) => {
    const node = nodes.find(n => n.parsedMessage.from === fromId);
    if (!node) return fromId;
    return `${node.parsedMessage.payload.longname} (${node.parsedMessage.payload.shortname})`;
  };

  return (
    <div className={`w-full max-w-screen-2xl mx-auto p-6 pb-16 ${darkMode ? 'text-white bg-gray-900' : 'text-black bg-white'}`}>
      <h2 className="text-3xl font-bold mb-6">Messages for Channel: {channel}</h2>

      <div className="flex flex-wrap gap-6 mb-8 items-end bg-gray-100 dark:bg-gray-800 p-4 rounded-lg">
        <label className="flex flex-col text-sm">
          From Node:
          <select
            value={fromFilter}
            onChange={(e) => setFromFilter(e.target.value)}
            className="mt-1 border px-3 py-2 rounded bg-white dark:bg-gray-700 dark:text-white dark:border-gray-600"
          >
            <option value="">All Nodes</option>
            {nodes.map(n => (
              <option key={n._id} value={n.parsedMessage.from}>
                {n.parsedMessage.payload.longname} ({n.parsedMessage.payload.shortname})
              </option>
            ))}
          </select>
        </label>

        <label className="flex flex-col text-sm">
          Start Date:
          <input
            type="datetime-local"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="mt-1 border px-3 py-2 rounded bg-white dark:bg-gray-700 dark:text-white dark:border-gray-600"
          />
        </label>

        <label className="flex flex-col text-sm">
          End Date:
          <input
            type="datetime-local"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="mt-1 border px-3 py-2 rounded bg-white dark:bg-gray-700 dark:text-white dark:border-gray-600"
          />
        </label>

        <button
          onClick={fetchMessages}
          className="h-fit px-5 py-2 mt-5 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Apply Filters
        </button>
      </div>

      <div className="space-y-4">
        {filtered.map(msg => (
          <div key={msg._id} className="p-4 border rounded bg-white dark:bg-gray-800 shadow">
            <p className="text-sm text-gray-500 dark:text-gray-300">{new Date(msg.timestamp).toLocaleString()}</p>
            <p className="text-sm text-gray-500 dark:text-gray-300">
              From: <Link to={`/meshtastic/nodes/${msg.parsedMessage.from}`} className="text-blue-500 hover:underline">
                {getNodeName(msg.parsedMessage.from)}
              </Link>
            </p>
            <p className="text-lg mt-2">{msg.parsedMessage.payload?.text || '[no text]'}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ChannelMessageViewer;